import {CONFIG} from '../../appConfig';
import STATE from '../../constants/state';

const REFERENCE = 'reference/';

export default {
  /**
   * @desc Gets list of partner rewards programmes by country code
   * @param {Object} data {params}
   * @returns {Object}
   * @memberof services.gma.reference
   * @example
   * const countryCode = 'US';
   * services.gma.reference.partnerRewards({params: {countryCode}});
   * // dispatched results stored in `state.gmi.gma.reference.partner_rewards[countryCode]`
   */
  partnerRewards(data = {}) {
    const {params = {}} = data;
    return {
      method: 'GET',
      origin: CONFIG.GMA_ORIGIN_URL,
      endpoint: `${REFERENCE}partnerRewards`,
      params,
      statePath: STATE.GMA.REFERENCE.PARTNER_REWARDS.concat([params.countryCode])
    };
  },

  /**
   * @desc Get profile security questions
   * @param {Object} data {params}
   * @returns {Object}
   * @memberof services.gma.reference
   * @example
   * services.gma.reference.securityQuestions();
   * // dispatched results stored in `state.gmi.gma.reference.security_questions`
   */
  securityQuestions(data = {}){
    const {params = {}} = data;
    return {
      method: 'GET',
      origin: CONFIG.GMA_ORIGIN_URL,
      endpoint: `${REFERENCE}securityquestions`,
      params,
      statePath: STATE.GMA.REFERENCE.SECURITY_QUESTIONS
    };
  }
};
